/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 ocean.glb 
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export function Ocean(props) {
  const { nodes, materials } = useGLTF('/media/models/ocean.glb')
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.Sphere.geometry} material={materials['Material.001']} />
    </group>
  )
}

useGLTF.preload('/media/models/ocean.glb')
